import useDebouncedValue from "../../hooks/useDebouncedValue";

export { useDebouncedValue };

export const SEARCH_DEBOUNCE_MS = 400;

const isActiveFilter = (value) => value !== "" && value !== "all" && value !== undefined && value !== null;

// Search/filter request params shared by the vehicle list, grid and chart endpoints
export const buildFilterParams = (query) => {
  let params = {};
  if (query?.search) params.search = query.search;
  if (isActiveFilter(query?.property)) params.property_id = query.property;
  if (isActiveFilter(query?.apartment)) params.apt_id = query.apartment;
  if (isActiveFilter(query?.type)) params.is_guest = query.type;
  if (isActiveFilter(query?.status)) params.is_disabled = query.status;
  return params;
};
